<template>
  <DModal :show-close="false">
    <div class="d-modal" slot="insertComponent">
      <div class="d-modal__header">
        <h2>{{ i18n[locale].modal_title }}</h2>
        <div class="d-modal__close icon__bg-circle" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="d-modal__content" v-if="sms">
        <div class="meta">
          <div class="meta__row"><strong>{{ i18n[locale].user }}:</strong> {{ activeUser && activeUser.name ? activeUser.name : '—' }}</div>
          <div class="meta__row"><strong>{{ i18n[locale].sent }}:</strong> {{ humanTime }}</div>
          <div class="meta__row"><strong>{{ i18n[locale].phone }}:</strong> {{ sms.phone || '—' }}</div>
        </div>

        <div class="message">
          <label>{{ i18n[locale].content }}</label>
          <div class="message__box">{{ sms.message }}</div>
        </div>
      </div>

      <div class="d-modal__content" v-else>
        <i>{{ i18n[locale].no_previous }}</i>
      </div>

      <div class="d-modal__buttons pad-1">
        <button class="bttn submit-button" @click="$emit('close')">{{ i18n[locale].close }}</button>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../common/DModal'
import moment from 'moment'

const I18N = {
  da: {
    modal_title: 'Senest sendte besked',
    user: 'Bruger',
    sent: 'Sendt',
    phone: 'Telefon',
    content: 'Indhold',
    no_previous: 'Der er ingen tidligere besked til denne bruger',
    close: 'Luk'
  },
  nb: {
    modal_title: 'Sist sendte melding',
    user: 'Bruker',
    sent: 'Sendt',
    phone: 'Telefon',
    content: 'Innhold',
    no_previous: 'Det finnes ingen tidligere melding til denne brukeren',
    close: 'Lukk'
  },
  en: {
    modal_title: 'Most recent message',
    user: 'User',
    sent: 'Sent',
    phone: 'Phone',
    content: 'Content',
    no_previous: 'There is no previous message to this user',
    close: 'Close'
  }
}

export default {
  components: { DModal },
  props: {
    activeUser: { type: Object, default: null },
    sms: { type: Object, default: null }
  },
  computed: {
    i18n () {
      return I18N
    },
    locale () {
      return this.$store.getters.locale
    },
    humanTime () {
      if (!this.sms || !this.sms.created_at) return ''
      return moment(this.sms.created_at).format('lll')
    }
  }
}
</script>

<style scoped>
.d-modal {
  width: 420px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  padding: 1rem;
  text-align: left;
}

.d-modal__content {
  padding: 1rem;
}

.d-modal__close {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 16px !important;
}

.d-modal__buttons {
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
}

.meta {
  margin-bottom: 1rem
}
.meta__row {
  margin-bottom: .25rem
}

.message label {
  color: #a2a3a6;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: .065rem;
}

.message__box {
  white-space: pre-wrap;
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  padding: .75rem;
  line-height: 1.4
}
</style>



// WEBPACK FOOTER //
// SendMessagesPastSmses.vue?607f8b6e